import React, { memo } from 'react'

export const Education = () => {
  return (
    <div>Education</div>
  )
}

